export default __webpack_public_path__ + "static/media/logo.0c7e1d94.png";